import {Injectable} from "@angular/core";
import {ColDef} from "ag-grid-community";
import {DatePipe} from "@angular/common";
import {IEmailAuditSummary} from "../interfaces/email-audit/IEmailAuditSummary";

@Injectable({
  providedIn: 'root'
})
export class EmailAuditTable {

  constructor(private datePipe: DatePipe) {
  }

  public columnDefs(includeGameP: boolean): ColDef<IEmailAuditSummary>[] {
    const column_defs: ColDef<IEmailAuditSummary>[] = [
      {
        headerName: "Sent",
        field: "CreatedOn",
        resizable: true,
        valueFormatter: params => this.datePipe.transform(params.value, 'MMM d, y, h:mm a') ?? ''
      },
      {
        headerName: "Kind",
        field: "EmailTemplateTypeName",
        resizable: true
      },
      {
        headerName: "Recipient",
        field: "Recipient",
        resizable: true,
        valueFormatter: params => params.data?.IsBcc ? `${params.value} (BCC)` : params.value
      },
      {
        headerName: "Subject",
        field: "Subject",
        resizable: true,
        tooltipField: "Subject"
      },
      {
        headerName: "Status",
        field: "EmailAuditStatusName",
        resizable: true
      }
    ];

    if (includeGameP) {
      column_defs.push({
        headerName: "Game",
        field: "GameName",
        resizable: true,
        valueFormatter: params => params.value ?? 'No game'
      });
    }

    return column_defs;
  }
}
